var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42173",
    "data-name": "Group 42173",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 149.999,
    viewBox: "0 0 150 149.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20939",
    "data-name": "Path 20939",
    d: "M325.619,309.506a75,75,0,1,1-74.96-74.887A75.13,75.13,0,0,1,325.619,309.506Zm-9.391.158a65.613,65.613,0,1,0-65.583,65.563A65.714,65.714,0,0,0,316.228,309.664Z",
    transform: "translate(-175.619 -234.619)",
    fill: "#674188"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20940",
    "data-name": "Path 20940",
    d: "M223.047,278.293c-18.775-.659-31.988-7.6-41.022-21.964-1.694-2.689-1.4-5.206.593-6.834,2.4-1.964,5.391-1.272,7.348,1.871a35.643,35.643,0,0,0,16.2,14.254,36.4,36.4,0,0,0,45.5-13.634c.857-1.318,2.175-2.965,3.493-3.183a6.617,6.617,0,0,1,4.857,1.529c1.687,1.5,1.338,3.723.178,5.647-5.826,9.648-14.023,16.461-24.778,19.809C230.81,277.22,225.92,277.733,223.047,278.293Z",
    transform: "translate(-145.998 -157.607)",
    fill: "#674188"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20941",
    "data-name": "Path 20941",
    d: "M199.614,251.173a9.237,9.237,0,0,1-9.279,9.312,9.355,9.355,0,1,1,.066-18.709A9.279,9.279,0,0,1,199.614,251.173Z",
    transform: "translate(-146.15 -194.618)",
    fill: "#674188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20942",
    "data-name": "Path 20942",
    d: "M190.268,251.268a9.267,9.267,0,0,1,9.114-9.489,9.35,9.35,0,1,1,.257,18.7A9.218,9.218,0,0,1,190.268,251.268Z",
    transform: "translate(-93.733 -194.614)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/Smile.efa7b608b625d629007fd071394171bd.svg";
export { ForwardRef as ReactComponent };